export const videosEditMixin = (type = 'pre-training') => ({
  props: {
    serie: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    showModal: {
      type: Boolean,
      required: false,
      default: false,
    },
    language: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      video: {},
    };
  },
  methods: {
    async fetchVideo(http, id, lang_code) {
      const endpoints = {
        'pre-training': `/admin/pre-training/${id}`,
        'post-training-videos': `/admin/post-training-videos/${id}`,
        'training-videos': `/admin/training-videos/${id}`,
      };
      const res = await http.get(endpoints[type], { params: { lang_code } });
      const video = res.data.data;

      // send video's title up to the parent component to show on the header
      this.$emit('edit', video.title);

      return video;
    },
  },
  async mounted() {
    this.video = await this.fetchVideo(this.$http, this.$route.params.id, this.language.code);
  },
});
